export const COLLECTION_REQUEST = 'COLLECTION_REQUEST';
export const COLLECTION_SUCCESS = 'COLLECTION_SUCCESS';
export const COLLECTION_FAILURE = 'COLLECTION_FAILURE';

export const WIDGET_DATA_REQUEST = 'WIDGET_DATA_REQUEST';
export const WIDGET_DATA_SUCCESS = 'WIDGET_DATA_SUCCESS';
export const WIDGET_DATA_FAILURE = 'WIDGET_DATA_FAILURE';

export const EXPORT_WIDGET_TO_CSV_REQUEST = 'EXPORT_WIDGET_TO_CSV_REQUEST';
export const EXPORT_WIDGET_TO_CSV_SUCCESS = 'EXPORT_WIDGET_TO_CSV_SUCCESS';
export const EXPORT_WIDGET_TO_CSV_FAILURE = 'EXPORT_WIDGET_TO_CSV_FAILURE';

export const TOGGLE_WIDGET_TABLE_COLUMN = 'TOGGLE_WIDGET_TABLE_COLUMN';
export const RESET_WIDGET_TABLE_COLUMN = 'RESET_WIDGET_TABLE_COLUMN';
